export default "__VITE_ASSET__d55cdc73__"